export default __webpack_public_path__ + "static/media/logo.4eb61788.svg";